import React from 'react';

import { useTheme } from '@chakra-ui/react';

import { TextLabel } from 'uiToolkitV1/Typography';

const LABEL_STATES = {
  vertical: 'vertical',
  horizontal: 'horizontal',
};
export const Label = ({
  children,
  Icon = null,
  mandatory = false,
  active = false,
  labelState = LABEL_STATES.vertical,
  ...props
}) => {
  const theme = useTheme();
  /* Icon, labelState to implemented */
  return (
    <TextLabel {...props} color={active ? theme.colors.button.blue.focus : theme.colors.text.g2}>
      {children} {mandatory ? ' *' : ''}
    </TextLabel>
  );
};
